import * as Sentry from "@sentry/react";
import { CONFIG } from "@/lib/config.ts";

const sentryDns = CONFIG.SENTRY_DSN;
const sentryEnvironment = CONFIG.SENTRY_ENVIRONMENT;

export function initSentry() {
  Sentry.init({
    dsn: sentryDns,
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: sentryEnvironment || undefined,
  });
}

export function logError(error: unknown) {
  if (error instanceof Error) Sentry.captureException(error);
}
